import { FC } from 'react'
import { ContactBasicInfo } from '../../../../../../hooks/useContactBasicInfo'
import TowInputText from '../../../../../UtilComponent/level_2/TowInputText'
import TowInputTextWithSecondNode from '../../../../../UtilComponent/level_2/TowInputTextWithSecondNode'
import ContactPhoneLabel from '../../PhoneLabel/ContactPhoneLabel'

type Props = ContactBasicInfo

const CreateContactBasic: FC<Props> = (props) => {
  const {
    firstNameInput,
    lastNameInput,
    lastNameKanaInput,
    firstNameKanaInput,
    emailInput,
    externalNumbers,
    addExternalNumber,
    updateExternalNumber,
    removeExternalNumber,
    showLabelListIndex,
    setShowLabelListIndex,
  } = props

  return (
    <>
      <TowInputText first={lastNameInput} second={firstNameInput} />
      <TowInputText first={lastNameKanaInput} second={firstNameKanaInput} />

      <TowInputTextWithSecondNode
        first={emailInput}
        second={
          <ContactPhoneLabel
            externalNumbers={externalNumbers}
            addExternalNumber={addExternalNumber}
            updateExternalNumber={updateExternalNumber}
            removeExternalNumber={removeExternalNumber}
            showLabelListIndex={showLabelListIndex}
            setShowLabelListIndex={setShowLabelListIndex}
          />
        }
      />
    </>
  )
}

export default CreateContactBasic
